module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group-item order-address-form__form-group-item--single"
  }, [_vm._m(0), _vm._v(" "), (_vm.$parent.commentText) ? _c('p', {
    staticClass: "order-address-form__additional-label-info"
  }, [_vm._v("\n        " + _vm._s(_vm.$parent.commentText) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form.comment),
      expression: "$parent.form.comment",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "order-address-form__textarea form-control",
    attrs: {
      "name": "comment"
    },
    domProps: {
      "value": (_vm.$parent.form.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form, "comment", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "comment"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            Kommentar\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fb056b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/Comment.vue
// module id = 850
// module chunks = 0